@use "@fukuri-admins/ui/layout" as *;

.badge {
  display: inline-flex;
  align-items: center;
  gap: spacing('8');
  border-radius: spacing('8');
  white-space: nowrap;
}

.sm {
  padding: spacing('2') spacing('6');
  @include typography('Jp/12_W3');
}

.md {
  padding: spacing('4') spacing('8');
  @include typography('Jp/12_W3');
}

.lg {
  padding: spacing('6') spacing('12');
  @include typography('Jp/14_W3');
}

.solid {
  color: text('White');
  &.neutral {
    background-color: background('Gray');
  }

  &.info {
    background-color: background('Sky_Darken');
  }

  &.success {
    background-color: background('Green_Darken');
  }

  &.warning {
    background-color: background('Orange_Darken');
  }

  &.negative {
    background-color: background('Red_Darken');
  }
}

.outline {
  background-color: background('Primary');
  border: 1px solid;

  &.neutral {
    border-color: border('Gray');
    color: text('Middle');
  }

  &.info {
    border-color: text('Sky');
    color: text('Link');
  }

  &.success {
    border-color: text('Green');
    color: text('Green');
  }

  &.warning {
    border-color: text('Orange');
    color: text('Orange');
  }

  &.negative {
    border-color: text('Red');
    color: text('Red');
  }
}

.subtle {
  &.neutral {
    background-color: background('Secondary');
    color: text('Middle');
  }

  &.info {
    background-color: background('Sky');
    color: text('Link');
  }

  &.success {
    background-color: background('Green');
    color: text('Green');
  }

  &.warning {
    background-color: background('Orange');
    color: text('Orange');
  }

  &.negative {
    background-color: background('Red');
    color: text('Red');
  }
}

%focus-visible {
  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: spacing('2') solid border('Focus');
    box-shadow: 0 0 0 spacing('2') border('Focus');
    border-radius: spacing('2');
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
}

.closeButton {
  @extend %focus-visible;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: spacing('2');
  padding: spacing('2');
  color: inherit;
  transition: background-color 0.2s;

  // svgIcon クラスが color: text('High') を持つため、詳細度を上げて上書きする
  svg {
    color: inherit;
  }
}

// Close button size variants
.closeButtonSm {
  padding: spacing('2');
}

.closeButtonMd {
  padding: spacing('2');
}

.closeButtonLg {
  padding: spacing('4');
}
